// SidebarMenu.js

import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FaAngleDown } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const menuAnimation = {
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0,
    transition: { duration: 0.3, when: "afterChildren" },
  },
  show: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.3,
      when: "beforeChildren",
    },
  },
};
const menuItemAnimation = {
  hidden: (i) => ({
    padding: 0,
    x: "-100%",
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
  show: (i) => ({
    x: 0,
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
};

const SidebarMenu = ({ route, showAnimation, isOpen, setIsOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasFurtherSubRoutes, setHasFurtherSubRoutes] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsOpen(true);
  };

  useEffect(() => {
    if (!isOpen) {
      setIsMenuOpen(false);
    }
  }, [isOpen]);

  useEffect(() => {
    // Check if any subRoutes have further subRoutes
    const subRoutesWithFurtherSubRoutes = route.subRoutes && route.subRoutes.some(subRoute => subRoute.subRoutes);
    setHasFurtherSubRoutes(subRoutesWithFurtherSubRoutes);
  }, [route.subRoutes]);

  return (
    <>
      {/* <div className="menu" onClick={toggleMenu}> */}
      <div className={`menu ${hasFurtherSubRoutes ? 'has-further-subroutes' : ''}`} onClick={toggleMenu}>
        <div className="menu_item">
          <div className="icon">{route.icon}</div>
          <AnimatePresence>
            {isOpen && (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="link_text"
              >
                {route.name}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {isOpen && (
          <motion.div
            animate={
              isMenuOpen
                ? {
                  rotate: -90,
                }
                : { rotate: 0 }
            }
          >
            <FaAngleDown />
          </motion.div>
        )}
      </div>
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            variants={menuAnimation}
            initial="hidden"
            animate="show"
            exit="hidden"
            // className="menu_container"
            className={`menu_container ${hasFurtherSubRoutes ? 'sub-menu-has-further-subroutes xx-submenu' : ''}`}
          >
            {route.subRoutes &&
              route.subRoutes.map((subRoute, i) => (
                <motion.div variants={menuItemAnimation} key={i} custom={i}>
                  {subRoute.visible && subRoute !== route && ( // Check visibility
                    <>

                      {!subRoute.subRoutes && (
                        <NavLink to={subRoute.path} className="link submenu-flex" >
                          <div className="icon sub-icon">{subRoute.icon}</div>
                          <motion.div className="link_text" >
                            {subRoute.name}
                          </motion.div>
                        </NavLink>
                      )}
                      {subRoute.subRoutes && (
                        <SidebarMenu
                          route={subRoute}
                          showAnimation={showAnimation}
                          isOpen={isOpen}
                          setIsOpen={setIsOpen}
                        />
                      )}
                    </>
                  )}
                </motion.div>
              ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarMenu;
